module.exports = __webpack_public_path__ + "static/media/05.1575ed7e.jpg";